import { ProviderConnection } from "@/components/pages/integrations/components/common/types/common";

export const providerConnectionDetails: Record<
  ProviderConnection,
  Record<string, string>
> = {
  snowflake: {
    drawerTitle: "Connect Cluster",
    label: "Snowflake",
    description:
      "Connect your Snowflake billing data to track and analyze your resources and costs in Billing Explorer.",
    noDataDescription: "No Snowflake data connected",
    connectionType: "billing_export",
  },
};
